export default "/images/1ab355223cdde4bd10e8a8f1b7c241a9.png";